import {
  useElementContext,
  removePromoCode,
  disableInteractionSelector,
  applyPromoCode,
} from "@ten24/slatwall-storefront-react-private/global";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CartCheckOut = ({ cartOrderItems, quoteOrderItems }) => {
  const { CartPromoBox, OrderSummary } = useElementContext();
  const cart = useSelector((state) => state.cart);
  const disableInteraction = useSelector(disableInteractionSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      {quoteOrderItems.length > 0 ? (
        <>
          <h3><b>Checkout Options</b></h3>
          <p>
            You have some items in your cart which must go to the seller for a
            quote. We can create this quote for you and send it off to the
            seller as part of the checlkout process.
          </p>
          <p>
            You can also choose to send all items to the seller for a quote.
          </p>

          <p className="fst-italic">
            {cartOrderItems.length > 1
              ? `${cartOrderItems.length} Items`
              : `${cartOrderItems.length} Item`}{" "}
            can be ordered immediately
            <br />
            {quoteOrderItems.length > 1
              ? `${quoteOrderItems.length} Items`
              : `${quoteOrderItems.length} Item`}{" "}
            Items need to be sen to the seller for a quote
          </p>

          <div className="col-12">
            <button
              className="btn btn-success rounded checkout-btn"
              onClick={() => {
                navigate({
                  pathname: "/quotes-in-cart",
                  search: `allItems=0`,
                });
              }}
            >
              Checkout{" "}
              {cartOrderItems.length > 1
                ? `${cartOrderItems.length} Items`
                : `${cartOrderItems.length} Item`}{" "}
              now and create a quote with {quoteOrderItems.length} items
            </button>
          </div>
          <div className="col-12 my-2">
            <button
              className="btn btn-success rounded w-100 checkout-btn"
              onClick={() => {
                navigate({
                  pathname: "/quotes-in-cart",
                  search: `allItems=1`,
                });
              }}
            >
              Send all{" "}
              {cartOrderItems.length + quoteOrderItems.length > 1
                ? `${cartOrderItems.length + quoteOrderItems.length} Items`
                : `${cartOrderItems.length + quoteOrderItems.length} Item`}{" "}
              items to a quote
            </button>
          </div>
        </>
      ) : (
        <div className="row">
          <div className="col-sm-12">
            <OrderSummary
              cart={cart}
              disabled={disableInteraction}
              onRemovePromoCode={(event, promotionCode) => {
                event.preventDefault();
                dispatch(
                  removePromoCode(
                    promotionCode,
                    undefined,
                    t("frontend.cart.promo_code_removed")
                  )
                );
              }}
            />
          </div>
          <CartPromoBox
            disabledInteraction={disableInteraction}
            onApplyCode={(promoCode, setPromoCode) => {
              dispatch(
                applyPromoCode(promoCode, t("frontend.cart.promo_code_applied"))
              );
              setPromoCode("");
            }}
          />
          <div className="ps-2 pe-2">
            <button
              className="col-md-12 btn btn-primary w-100 mt-2 "
              disabled={disableInteraction}
              onClick={(e) => {
                e.preventDefault();
                navigate("/checkout");
              }}
            >
              {t("frontend.order.to_checkout")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export { CartCheckOut };
